import { render, staticRenderFns } from "./InfoOverview.vue?vue&type=template&id=0778c25a&"
import script from "./InfoOverview.vue?vue&type=script&lang=js&"
export * from "./InfoOverview.vue?vue&type=script&lang=js&"
import style0 from "./InfoOverview.vue?vue&type=style&index=0&id=0778c25a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection})
